import StoreApplicationState from "@store/Store/StoreApplicationState";

export const getHasRelatedProducts = (state: StoreApplicationState) => {
    const { hasRelatedProducts } = state.store.pages.productDetails;

    return Boolean(hasRelatedProducts);
};